import { Store } from '../../../../../services/storesServices'
import { StoresTableRow } from './StoresTableRow'

interface TableProps {
  stores: Store[]
  onEdit: (store: Store) => void
  onEditStoreGroup: (storeGroupId: string) => void
}

export function StoresTable({ stores, onEdit, onEditStoreGroup }: TableProps) {
  if (stores.length === 0) {
    return (
      <div className="flex items-center justify-center w-full">
        <strong className="text-center">Nenhuma loja encontrada</strong>
      </div>
    )
  }

  return (
    <div
      className="overflow-x-auto mt-4 md:mt-2 w-full border border-slate-500 rounded-lg"
    >
      <table
        className="flex-1 w-full text-sm text-left rounded-t-md overflow-hidden"
      >
        <thead className="text-xs bg-opacity-80">
          <tr>
            <th
              scope="col"
              className="px-4 py-3 text-center border-r w-[16rem] border-slate-500"
            >
              Grupo
            </th>
            <th
              scope="col"
              className="px-4 py-3 text-center border-r w-[16rem] border-slate-500"
            >
              Nome
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 text-center"
            >
              Cidade e Estado
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 text-center"
            >
              Vendedor
            </th>
            <th
              scope="col"
              className="px-4 py-3  border-r border-slate-500 text-center"
            >
              Supervisor
            </th>
            <th
              scope="col"
              className="px-4 py-3 w-16 text-center"
            >
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {stores.map(store => (
            <StoresTableRow key={store.id} store={store} onEdit={onEdit} onEditStoreGroup={onEditStoreGroup} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
